import { DragDropListItemProps } from '@components-clean/core/drag-drop-lists-core/drag-drop-lists-core.interface';

export function createFakeDataItem(index: number): DragDropListItemProps {
    return {
        title: `Title ${index}`,
        subtitle: `Subtitle ${index}`,
        active: true,
        panelId: index,
        displayIndex: 0,
    };
}

const DragAndDropListData: { left: DragDropListItemProps[]; right: DragDropListItemProps[] } = {
    left: [
        {
            title: 'CRF Data Entry',
            subtitle: 'Subtitle',
            active: true,
            panelId: 1,
            displayIndex: 0,
            metadata: {
                recordId: 'Record ID Value',
                configId: 'Config ID Value',
                createdDate: new Date(2024, 0, 1),
                updatedDate: new Date(2024, 1, 1),
                createdBy: 'John Smith',
                updatedBy: 'Jane Doe',
            },
        },
        {
            title: 'Query Response',
            subtitle: 'Subtitle',
            active: true,
            panelId: 4,
            displayIndex: 0,
            metadata: {
                recordId: 'Record ID Value',
                configId: 'Config ID Value',
                createdDate: new Date(2024, 0, 1),
                updatedDate: new Date(2024, 1, 1),
                createdBy: 'John Smith',
                updatedBy: 'Jane Doe',
            },
        },
        {
            title: 'Manual Queries Funnel',
            subtitle: 'Subtitle',
            active: false,
            panelId: 5,
            displayIndex: 0,
            metadata: {
                recordId: 'Record ID Value',
                configId: 'Config ID Value',
                createdDate: new Date(2024, 0, 1),
                updatedDate: new Date(2024, 1, 1),
                createdBy: 'John Smith',
                updatedBy: 'Jane Doe',
            },
        },
        {
            title: 'Site Action Rate Funnel',
            subtitle: 'Subtitle',
            active: true,
            panelId: 21,
            displayIndex: 0,
            metadata: {
                recordId: 'Record ID Value',
                configId: 'Config ID Value',
                createdDate: new Date(2024, 0, 1),
                updatedDate: new Date(2024, 1, 1),
                createdBy: 'John Smith',
                updatedBy: 'Jane Doe',
            },
        },
        {
            title: 'Missed Visits (sub) Rate',
            subtitle: 'Subtitle',
            active: true,
            panelId: 22,
            displayIndex: 0,
            metadata: {
                recordId: 'Record ID Value',
                configId: 'Config ID Value',
                createdDate: new Date(2024, 0, 1),
                updatedDate: new Date(2024, 1, 1),
                createdBy: 'John Smith',
                updatedBy: 'Jane Doe',
            },
        },
    ],
    right: [
        {
            title: 'Screen Failure',
            subtitle: 'Subtitle',
            active: true,
            panelId: 30,
            displayIndex: 0,
            metadata: {
                recordId: 'Record ID Value',
                configId: 'Config ID Value',
                createdDate: new Date(2024, 0, 1),
                updatedDate: new Date(2024, 1, 1),
                createdBy: 'John Smith',
                updatedBy: 'Jane Doe',
            },
        },
        {
            title: 'Early Discontinuation',
            subtitle: 'Subtitle',
            active: true,
            panelId: 31,
            displayIndex: 0,
            metadata: {
                recordId: 'Record ID Value',
                configId: 'Config ID Value',
                createdDate: new Date(2024, 0, 1),
                updatedDate: new Date(2024, 1, 1),
                createdBy: 'John Smith',
                updatedBy: 'Jane Doe',
            },
        },
        {
            title: 'System Queries Funnel',
            subtitle: 'Subtitle',
            active: true,
            panelId: 32,
            displayIndex: 0,
            metadata: {
                recordId: 'Record ID Value',
                configId: 'Config ID Value',
                createdDate: new Date(2024, 0, 1),
                updatedDate: new Date(2024, 1, 1),
                createdBy: 'John Smith',
                updatedBy: 'Jane Doe',
            },
        },
        {
            title: 'SAE Rate Funnel',
            subtitle: 'Subtitle',
            active: true,
            panelId: 33,
            displayIndex: 0,
            metadata: {
                recordId: 'Record ID Value',
                configId: 'Config ID Value',
                createdDate: new Date(2024, 0, 1),
                updatedDate: new Date(2024, 1, 1),
                createdBy: 'John Smith',
                updatedBy: 'Jane Doe',
            },
        },
        {
            title: 'Manual Queries',
            subtitle: 'Subtitle',
            active: true,
            panelId: 35,
            displayIndex: 0,
            metadata: {
                recordId: 'Record ID Value',
                configId: 'Config ID Value',
                createdDate: new Date(2024, 0, 1),
                updatedDate: new Date(2024, 1, 1),
                createdBy: 'John Smith',
                updatedBy: 'Jane Doe',
            },
        },
        {
            title: 'Auto Query',
            subtitle: 'Subtitle',
            active: true,
            panelId: 36,
            displayIndex: 0,
            metadata: {
                recordId: 'Record ID Value',
                configId: 'Config ID Value',
                createdDate: new Date(2024, 0, 1),
                updatedDate: new Date(2024, 1, 1),
                createdBy: 'John Smith',
                updatedBy: 'Jane Doe',
            },
        },
    ],
};

export default DragAndDropListData;
